module.exports = __webpack_public_path__ + "img/img58.080574bd.png";